
import { Badge } from "@/components/ui/badge";
import { TrendingUp, TrendingDown, Activity, Shield, AlertTriangle, Target, AlertCircle, CheckCircle, XCircle } from "lucide-react";

export const getTrendConfluenceBadge = (confluence?: string) => {
  if (!confluence) return null;
  
  const configs = {
    'STRONG': { icon: TrendingUp, text: 'Strong Trend', color: 'bg-green-600/20 text-green-800 border-green-600/30' },
    'PULLBACK': { icon: Activity, text: 'Pullback', color: 'bg-blue-500/20 text-blue-700 border-blue-500/30' },
    'REVERSAL': { icon: AlertTriangle, text: 'Reversal Signal', color: 'bg-orange-500/20 text-orange-700 border-orange-500/30' },
    'MAJOR_REVERSAL': { icon: TrendingDown, text: 'Major Reversal', color: 'bg-red-600/20 text-red-800 border-red-600/30' }
  };
  
  const config = configs[confluence as keyof typeof configs];
  if (!config) return <Badge variant="outline">{confluence}</Badge>;
  
  const Icon = config.icon;
  return (
    <Badge className={`${config.color} flex items-center gap-1`}>
      <Icon className="h-3 w-3" />
      {config.text}
    </Badge>
  );
};

export const getMarketConditionBadge = (condition?: string) => {
  if (!condition) return null;
  
  const configs = {
    'STABLE': { icon: Shield, text: 'Stable Market', color: 'bg-green-500/20 text-green-700 border-green-500/30' },
    'NORMAL': { icon: Activity, text: 'Normal Volatility', color: 'bg-blue-500/20 text-blue-700 border-blue-500/30' },
    'VOLATILE': { icon: AlertTriangle, text: 'High Volatility', color: 'bg-red-500/20 text-red-700 border-red-500/30' }
  };
  
  const config = configs[condition as keyof typeof configs];
  if (!config) return <Badge variant="outline">{condition}</Badge>;
  
  const Icon = config.icon;
  return (
    <Badge className={`${config.color} flex items-center gap-1`}>
      <Icon className="h-3 w-3" />
      {config.text}
    </Badge>
  );
};

export const getActionBadge = (action: string) => {
  const configs = {
    'BUY': { icon: TrendingUp, color: 'bg-green-600/20 text-green-800 border-green-600/30' },
    'SELL': { icon: TrendingDown, color: 'bg-red-600/20 text-red-800 border-red-600/30' },
    'HOLD': { icon: Activity, color: 'bg-blue-500/20 text-blue-700 border-blue-500/30' },
    'WAIT_FOR_PULLBACK': { icon: Target, color: 'bg-yellow-500/20 text-yellow-700 border-yellow-500/30' },
    'CAUTION': { icon: AlertTriangle, color: 'bg-orange-500/20 text-orange-700 border-orange-500/30' },
    'AVOID': { icon: XCircle, color: 'bg-red-500/20 text-red-700 border-red-500/30' }
  };
  
  const config = configs[action as keyof typeof configs];
  if (!config) return <Badge variant="outline">{action}</Badge>;
  
  const Icon = config.icon;
  return (
    <Badge className={`${config.color} flex items-center gap-1`}>
      <Icon className="h-3 w-3" />
      {action.replace('_', ' ')}
    </Badge>
  );
};

export const getAlertSeverityBadge = (severity: string) => {
  const configs = {
    'HIGH': { icon: AlertCircle, color: 'bg-red-600/20 text-red-800 border-red-600/30' },
    'MEDIUM': { icon: AlertTriangle, color: 'bg-orange-500/20 text-orange-700 border-orange-500/30' },
    'INFO': { icon: CheckCircle, color: 'bg-blue-500/20 text-blue-700 border-blue-500/30' }
  };
  
  const config = configs[severity as keyof typeof configs];
  if (!config) return <Badge variant="outline">{severity}</Badge>;
  
  const Icon = config.icon;
  return (
    <Badge className={`${config.color} flex items-center gap-1`}>
      <Icon className="h-3 w-3" />
      {severity}
    </Badge>
  );
};
